import Column from '@components/column'
import { StyleCardWrapper, StyleTitle, styleColumn } from './style'
import { Formik, Form } from 'formik'
import { useState } from 'react'
import Fields from '@components/fields'
import Button from '@components/button'
import Container from '@components/container'
import { User } from '@apis'
import { AuthSchema } from '@validations'
import { useNavigate } from 'react-router-dom'
import { useSelector } from 'react-redux'
const ChangePassword = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState<boolean>(false)
  const { data: user } = useSelector((state: any) => state.user)
  const [initialValues] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  })
  const submitHandler = async (values: any) => {
    setLoading(true)
    await User.changePassword({
      data: {
        newPassword: values?.newPassword,
        currentPassword: values?.currentPassword,
      },
    })
      .then(() => {
        navigate(`/${user?.role}`)
      })
      .catch(() => {})
    setLoading(false)
  }
  return (
    <Container>
      <Column justifyContent="center" styleColumn={styleColumn}>
        <StyleCardWrapper>
          <StyleTitle>Change Password</StyleTitle>
          <Formik
            initialValues={initialValues}
            onSubmit={submitHandler}
            validationSchema={AuthSchema.passwordChangeValidationSchema}
          >
            {({ handleSubmit }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <Column styleColumn="margin-top:20px;" rowGap={20}>
                    <Fields.Password
                      name="currentPassword"
                      label="Current Password"
                      placeholder="Current Password"
                    />
                    <Fields.Password
                      name="newPassword"
                      label="New Password"
                      placeholder="New Password"
                    />
                    <Fields.Password
                      name="confirmPassword"
                      label="Confirm Password"
                      placeholder="Confirm Password"
                    />
                    <Column alignItems="flex-end">
                      <Button
                        type="submit"
                        title="Change"
                        height={45}
                        loading={loading}
                      />
                    </Column>
                  </Column>
                </Form>
              )
            }}
          </Formik>
        </StyleCardWrapper>
      </Column>
    </Container>
  )
}

export default ChangePassword
